module.exports = __webpack_public_path__ + "static/media/drink-drinking-healthy-life-svgrepo-com.899c1136.svg";